import { tv } from '@costar-ui/cosmos';
import baseModal from './theme/base-modal.esm.js';
import nextModal from './theme/next-modal.esm.js';

var base = tv(baseModal);
var next = tv(nextModal);
var modalStyles = {
  base: base,
  next: next
};

export { modalStyles };
//# sourceMappingURL=modal.styles.esm.js.map
